import Amplify from "aws-amplify";
import { getUserProfile } from "./UserProfilesService";

export const getCurrentUserProfile = async () => {
  const currentSessionData = await Amplify.Auth.currentSession();
  return await getUserProfile(
    currentSessionData.idToken.payload["cognito:username"]
  );
};
